{
  "fr": {
    "ai": {
      "activation": {
        "activate": "Activer",
        "activated": "L'assistant IA est activé pour {client}.",
        "agreement_required": "Cochez d'abord la case d'accord.",
        "deactivated": "L'assistant IA est désactivé pour {client}.",
        "not_now": "Pas maintenant",
        "prompt": {
          "agreement": "Au nom de {client}, je marque mon accord sur Google Cloud comme sous-traitant ultérieur pour cette fonctionnalité.",
          "dpa_label": "Accord de traitement des données mis à jour",
          "dpa_url": "https://ziggu.io/terms-and-conditions-13-10-2026",
          "intro": "Faites résumer les conversations et proposer des réponses. Gratuit à l'essai jusqu'au 31 décembre 2026.",
          "processing": "Pour utiliser l'assistant, le texte des conversations est traité via Google Cloud (Gemini) au sein de l'UE. Google n'utilise pas ces données pour entraîner des modèles.",
          "retention": "Nous conservons les conversations avec l'assistant pendant {count} mois. | Nous conservons les conversations avec l'assistant pendant {count} mois.",
          "settings": "Vous pouvez activer ou désactiver l'assistant à tout moment dans les paramètres, sous {features} > {conversations}.",
          "title": "Nouveau : assistant IA pour votre équipe projet"
        },
        "settings": {
          "description": "Résume les conversations et propose des réponses. L'activation demande votre accord sur Google Cloud comme sous-traitant ultérieur.",
          "impersonation": "Seuls les collègues avec le rôle Propriétaire peuvent l'activer ou le désactiver. Ce n'est pas possible lors d'un emprunt d'identité.",
          "owner_only": "Demandez à un propriétaire d'activer l'assistant IA.",
          "owner_only_enabled": "Seul un propriétaire peut désactiver l'assistant IA.",
          "title": "Assistant IA",
          "toggle": "Assistant IA dans les conversations"
        },
        "snoozed": "Vous pourrez activer l'assistant IA plus tard dans les paramètres, sous {features} > {conversations}."
      },
      "assistant": {
        "all_projects": "Tous les projets",
        "cap": {
          "action": "Démarrer une nouvelle conversation",
          "message": "Vous avez atteint la limite de conversation."
        },
        "empty_state": {
          "subtitle": "Posez-moi n'importe quelle question sur vos clients",
          "title": "Comment puis-je vous aider ?"
        },
        "errors": {
          "budget_reached": "Le budget IA de ce mois est épuisé. Contactez Ziggu pour l'augmenter.",
          "generic": "Une erreur s'est produite. Veuillez réessayer."
        },
        "history": {
          "empty": "Aucune conversation passée",
          "title": "Conversations passées"
        },
        "input": {
          "disclaimer": "Les résultats peuvent être inexacts. Vérifiez toujours les informations importantes.",
          "hint": "Entrée pour envoyer · Maj+Entrée pour nouvelle ligne",
          "placeholder": "Posez une question sur vos clients..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Comment configurer les notifications ?",
          "help_project_settings": "Où trouver les paramètres du projet ?",
          "open_decisions": "Quelles décisions sont encore ouvertes ?",
          "unassigned_units": "Quelles units n'ont pas encore de client ?"
        },
        "support_cta": {
          "action": "Contacter le support",
          "prompt": "Ce n'est pas la réponse que vous cherchiez ?"
        }
      },
      "dashboard": {
        "agents": {
          "all": "Tous les modules",
          "assistant": "Assistant",
          "conversation_agent": "Agent conversationnel",
          "label": "Module"
        },
        "allowance": {
          "edit": "Modifier le budget"
        },
        "allowance_boost": {
          "action": "Augmenter temporairement",
          "action_short": "Augmenter",
          "amount_label": "Montant supplémentaire",
          "existing": "Un supplément de {amount} est déjà actif cette période. Ce montant s'y ajoute.",
          "expires": "S'ajoute au budget pour cette période uniquement et expire le {date}.",
          "expires_next_reset": "S'ajoute au budget pour cette période uniquement et expire à la prochaine réinitialisation.",
          "save": "Ajouter le supplément",
          "saved": "Supplément de {amount} ajouté"
        },
        "allowance_history": {
          "empty": "Aucune modification",
          "empty_hint": "Ce client fonctionne toujours avec le budget qui lui a été attribué.",
          "entry": "{field} : {before} → {after}",
          "package_amount": "montant du forfait",
          "title": "Historique du budget",
          "unknown_author": "Inconnu"
        },
        "chat_detail": {
          "employee": "Collaborateur",
          "empty": "Cette conversation n'a aucun message",
          "feedback": {
            "down": "Mauvaise réponse",
            "up": "Bonne réponse"
          },
          "text_hidden": "Non partagé par l'employé",
          "title": "Conversation"
        },
        "chats": {
          "columns": {
            "cost": "Coût",
            "employee": "Collaborateur",
            "intent": "Intention",
            "ticket": "Ticket",
            "turns": "Tours",
            "when": "Quand"
          },
          "empty": "Aucune conversation sur cette période",
          "feedback_label": "Évaluation",
          "feedbacks": {
            "all": "Toutes les évaluations",
            "down": "Pouce vers le bas",
            "up": "Pouce vers le haut"
          },
          "intent_label": "Intention",
          "open": "Ouvrir la conversation",
          "title": "Conversations",
          "via": "via {name}"
        },
        "client": {
          "allowance_boost": "{amount} en supplément jusqu'au {date}",
          "allowance_boost_next_reset": "{amount} en supplément jusqu'à la prochaine réinitialisation",
          "allowance_free": "{amount} gratuit",
          "allowance_paid": "{amount} payant",
          "employees_active": "{count} collaborateur actif | {count} collaborateurs actifs",
          "over_since": "Dépassé depuis le {date}",
          "title": "{name} · IA",
          "used": "{used} sur {allowance} utilisés"
        },
        "clients": {
          "allowance_split": "Gratuit {free} · Payant {paid}",
          "allowance_split_boost": "Gratuit {free} · Payant {paid} · Supplément {boost}",
          "columns": {
            "actions": "Actions",
            "allowance": "Budget",
            "chats": "Conversations sur la période",
            "client": "Client",
            "spend": "Dépenses sur la période",
            "status": "Statut",
            "used": "Utilisé ce mois-ci"
          },
          "empty": "Aucun client n'a utilisé l'IA sur cette période",
          "export": "Exporter",
          "title": "Clients"
        },
        "empty_hint": "Aucun résultat pour ce module et cette période.",
        "intent_mix": {
          "empty": "Aucune conversation sur cette période",
          "row": "{chats} conversation · {amount} | {chats} conversations · {amount}",
          "title": "Répartition par intention"
        },
        "intents": {
          "all": "Toutes les intentions",
          "draft": "Rédiger une réponse",
          "none": "Sans intention",
          "question": "Demander",
          "summary": "Résumé"
        },
        "kpi": {
          "clients_active": "Clients actifs",
          "employees_active": "Collaborateurs actifs",
          "spend_month": "Dépenses ce mois-ci",
          "spend_month_detail": "Mois calendaire en cours",
          "spend_range": "Dépenses sur la période",
          "spend_range_detail": "{count} conversation sur cette période | {count} conversations sur cette période",
          "spend_today": "Dépenses aujourd'hui",
          "tickets_assisted": "Tickets assistés"
        },
        "load_failed": {
          "description": "Rechargez la page ou choisissez une autre période.",
          "title": "Impossible de charger l'utilisation de l'IA"
        },
        "range": {
          "label": "Période"
        },
        "spend": {
          "empty": "Aucune dépense sur cette période",
          "monthly_empty": "Aucune dépense sur les {months} derniers mois",
          "monthly_hint": "{months} derniers mois · indépendant de la période sélectionnée",
          "monthly_title": "Coût par mois",
          "monthly_total": "{amount} sur les {months} derniers mois · indépendant de la période sélectionnée",
          "title": "Dépenses par jour",
          "total": "{amount} sur la période",
          "view": {
            "label": "Afficher les dépenses",
            "per_day": "Par jour",
            "running_total": "Cumul"
          }
        },
        "status": {
          "over": "Budget dépassé",
          "over_days": "Dépassé · 1 jour | Dépassé · {count} jours"
        },
        "title": "Utilisation de l'IA"
      },
      "settings": {
        "budget": {
          "amount_error": "Saisissez un montant comme 2 ou 2.50",
          "boost_label": "Supplément temporaire",
          "boost_label_until": "Supplément temporaire jusqu'au {date}",
          "description": "Plafond mensuel pour l'utilisation de l'IA (phase de test). Recalculé en fonction de la consommation de tokens sur toutes les conversations ce mois-ci.",
          "free_label": "Budget gratuit",
          "override_help": "Laissez vide pour utiliser le montant du forfait ({amount}).",
          "override_label": "Budget gratuit personnalisé",
          "paid_label": "Budget payant",
          "save": "Enregistrer",
          "title": "Budget mensuel",
          "total_label": "Budget total",
          "usage_label": "Utilisé ce mois-ci",
          "usage_of": "Utilisé ce mois-ci, sur {amount}",
          "use_package_amount": "Utiliser le montant du forfait"
        },
        "description": "Configuration des fonctionnalités IA dans votre organisation.",
        "title": "Paramètres IA",
        "usage": {
          "description": "La part du crédit IA de ce mois-ci déjà utilisée. À 100 %, les fonctionnalités IA s'arrêtent jusqu'à la remise à zéro le mois prochain.",
          "title": "Utilisation de l'IA"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Ajuster",
          "ask": "Demander",
          "draft": "Rédiger une réponse",
          "draft_empty": "Pas encore de messages auxquels répondre",
          "follow_up": "Question de suivi",
          "follow_up_stop": "Arrêter le suivi",
          "new": "Nouvelle question",
          "summary": "Résumer la conversation",
          "summary_empty": "Pas encore de messages à résumer",
          "use_as_reply": "Utiliser comme réponse"
        },
        "adjusting_draft": "Ajustement de ce brouillon",
        "beta": "Bêta",
        "beta_tooltip": "Gratuit jusqu'à fin 2026. Ensuite, l'utilisation sera limitée.",
        "budget": {
          "description": "Le budget IA de ce mois est épuisé. Les réponses précédentes restent disponibles.",
          "request": "Nous avons épuisé le budget IA de ce mois et souhaitons l'augmenter.",
          "request_low": "Nous avons presque épuisé le budget IA de ce mois et souhaitons l'augmenter.",
          "title": "Budget IA atteint",
          "warn": "{percent} % du budget IA de ce mois utilisé."
        },
        "cap": "Cette discussion est devenue longue. Posez plutôt une nouvelle question.",
        "collapse": "Masquer l'assistant",
        "conversation": "Conversation",
        "digest": {
          "decisions_open": "aucune décision ouverte | 1 décision ouverte | {count} décisions ouvertes",
          "installments_unpaid": "aucune tranche impayée | 1 tranche impayée | {count} tranches impayées",
          "issues_open": "aucun point d’après-vente ouvert | 1 point d’après-vente ouvert | {count} points d’après-vente ouverts",
          "nothing_open": "Rien en suspens pour cette unité",
          "overdue": "{count} en retard",
          "title": "En un coup d'œil"
        },
        "earlier_answers": "Réponses précédentes",
        "empty": "Posez une question sur cette conversation, ou commencez par l'une de celles-ci.",
        "expand": "Afficher l'assistant",
        "feedback": {
          "bad": "Mauvaise réponse",
          "consent": "Ziggu verra cette conversation. Elle peut contenir des noms et des données de clients.",
          "consent_shared": "Cette conversation est déjà partagée avec Ziggu.",
          "good": "Bonne réponse",
          "note": "Qu'aurait-il dû dire ? (facultatif)",
          "send": "Envoyer",
          "share": "Partager avec Ziggu",
          "stop_sharing": "Arrêter le partage",
          "thanks": "Merci pour votre retour.",
          "thanks_shared": "Merci. Partagée avec Ziggu.",
          "undo": "Annuler"
        },
        "following_up": "Suivi de cette réponse",
        "footer": "Le support Ziggu ne lit ceci que si vous le partagez ou donnez accès à Ziggu. Les réponses sont générées par une IA et peuvent contenir des erreurs.",
        "footer_shared": "Vous avez partagé cette conversation avec Ziggu. Les réponses sont générées par une IA et peuvent contenir des erreurs.",
        "input": {
          "adjust_draft": "Ajuster ce brouillon, p. ex. plus court ou plus formel",
          "follow_up": "Poser une question de suivi",
          "label": "Votre question",
          "placeholder": "Question sur cette conversation"
        },
        "links": {
          "aftercare": "Après-vente",
          "decisions": "Décisions",
          "financials": "Finances"
        },
        "placeholders": {
          "confirm": {
            "accept": "Envoyer quand même",
            "header": "Envoyer avec des éléments à compléter ?",
            "message": "L’assistant a laissé 1 élément à compléter dans cette réponse. | L’assistant a laissé {count} éléments à compléter dans cette réponse."
          },
          "remaining": "1 élément à compléter | {count} éléments à compléter"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Remplacer",
            "header": "Remplacer votre texte ?",
            "message": "Le brouillon remplace le texte de la zone de réponse."
          }
        },
        "resize": "Redimensionner l'assistant",
        "suggestions": {
          "history": "Quel est l'historique avec ce client ?",
          "issues_open": "Combien de points d'après-vente restent ouverts ?",
          "undecided": "Qu'est-ce que ce client n'a pas encore décidé ?"
        },
        "thinking": "L'assistant travaille...",
        "title": "Assistant"
      }
    }
  }
}
